import Client from '@/repositories/Clients/AxiosClient';
import Config from '@/repositories/Clients/AxiosDefaultConfig';
import { prepareFilterParams, prepareOptionFilterParams } from '@/libs/helper';

const resource = `${Config.basePath}/v1/admin/report`;

export default {
  options(payload) {
    const queries = [{
      searchby: "name",
      searchoperator: "%",
      search: payload.search
    }];
    const params = prepareOptionFilterParams(payload, queries);
    return Client.post(resource, params, {
      headers: {
        action: "user-option",
      },
    });
  },
};
